import React, { useEffect, useMemo, useState } from "react";

import { Stack, Typography } from "@mui/material";
import {
  AutocompleteMultiSelect,
  SelectOption
} from "components/reports/AutocompleteMultiSelect/AutocompleteMultiSelect";
import { useDealActions, useMeasuresSelector } from "store";
import type { CardConfig, SummaryCardConfig } from "store/types";

interface Props {
  config: SummaryCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const SummarySettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  const { getMeasuresAction } = useDealActions();
  const measures = useMeasuresSelector();
  const [loadingMeasures, setLoadingMeasures] = useState(false);

  useEffect(() => {
    if (!measures.length) {
      setLoadingMeasures(true);
      getMeasuresAction().finally(() => setLoadingMeasures(false));
    }
  }, [measures.length, getMeasuresAction]);

  const measureOptions: SelectOption<string>[] = useMemo(
    () => measures.map((m) => ({ key: m.name, value: m.name, text: m.name })),
    [measures]
  );

  return (
    <Stack flexDirection="column" gap="10px">
      <AutocompleteMultiSelect
        key={config.parameter}
        defaultValue={measureOptions.find((o) => o.value === config.parameter)}
        options={measureOptions}
        label="Measure"
        selectAll={false}
        loading={loadingMeasures}
        onChange={(value) => onUpdateConfig({ ...config, parameter: (value as string) || undefined })}
      />
      <Typography sx={{ fontSize: 12, color: "#9CA3AF", lineHeight: "15px" }}>
        Select a measure to display Total, Average, Min, Max.
      </Typography>
    </Stack>
  );
};
